module.exports = __webpack_public_path__ + "static/media/challenge-share-image.360e1eb0.jpg";